var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"tit"},[_vm._v(_vm._s(_vm.$t('common').Activecenter))]),_c('div',{staticClass:"info"},[_c('img',{staticClass:"topimg",attrs:{"src":require("@/assets/img/activity_invite.png")}}),_c('div',{staticClass:"content ql-editor",domProps:{"innerHTML":_vm._s(_vm.$t('activity').inviteRewardTxt)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }